import React from "react";
import { Dimensions, Platform, View } from "react-native";

const MOBILE_WIDTH = 420;

// Inside an iframe the document grows with the page, so window height is no
// longer the device. A portrait iPad then looks like a tall phone and content
// is laid out wider than the mobile column.
const getFoldViewport = () => {
  const windowDimensions = Dimensions.get("window");
  const width = windowDimensions?.width ?? 0;
  let height = windowDimensions?.height ?? 0;
  if (
    Platform.OS === "web" &&
    typeof window !== "undefined" &&
    window.parent !== window &&
    window.screen?.availHeight
  ) {
    height = Math.min(height, window.screen.availHeight);
  }
  return { width, height };
};

const getFoldState = () => {
  const { width, height } = getFoldViewport();
  const aspectRatio = width > 0 ? height / width : 0;
  const isFold = width > 600 && aspectRatio < 1.7 && width < 900;
  return { isFold, deviceWidth: isFold ? MOBILE_WIDTH : width };
};

export const FoldableWrapper = ({ children }) => {
  const { isFold, deviceWidth } = getFoldState();

  return (
    <>
      {isFold ? (
        <View
          style={{
            flex: 1,
            backgroundColor: "black",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View style={{ width: deviceWidth, flex: 1 }}>{children}</View>
        </View>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </>
  );
};

export const useIsFoldable = () => getFoldState();
